import { render, staticRenderFns } from "./DayaDukungMain.vue?vue&type=template&id=0f22719d&scoped=true"
import script from "./DayaDukungMain.vue?vue&type=script&lang=js"
export * from "./DayaDukungMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22719d",
  null
  
)

export default component.exports